<template>
  <div>
    <a-list
      v-if="dataSource.length > 0"
      :data-source="dataSource"
      item-layout="vertical"
    >
      <a-list-item
        slot="renderItem"
        slot-scope="item">
        <beneficiary-item :item="item" />
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import AList from 'ant-design-vue/lib/list'
import BeneficiaryItem from './beneficiary-item'

export default {
  name: 'company-beneficiaries',
  components: {
    'a-list': AList,
    'a-list-item': AList.Item,
    BeneficiaryItem,
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data () {
    return {
      isEmpty: true,
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/list/style/index.css';
</style>
